import { memo } from "react";
import * as SearchResultType from "types/searchResult";
import { getExpirationDate } from "utility/whoisUtility";
import DomainResult from "components/domainResult/domainResult";
import { useAppSelector } from "hooks";
import { RootState } from "store";
import { resellersSelector } from "selectors/domainSelectors";

interface SearchResultProps {
  searchResult: SearchResultType.default;
  className?: string | undefined;
}

const SearchResult = (props: SearchResultProps) => {
  const { searchResult, className } = props;

  const expirationDate = getExpirationDate(searchResult.records);

  const resellers = useAppSelector((state: RootState) =>
    resellersSelector(state)
  );

  return (
    <>
      <DomainResult
        className={className}
        loading={searchResult.loading}
        resellers={resellers}
        key={searchResult.domain}
        name={searchResult.domain}
        expiresOn={expirationDate}
        records={searchResult.records}
      />
    </>
  );
};

export default memo(SearchResult);
